import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';

import Text from 'components/Text';

const Area = styled.textarea`
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  min-height: 100px;
  font-size: 0.86em;
  font-family: inherit;
  //border-radius: 4px;
    &:disabled{
    background-color: ${(props) => props.dbc ? '' : 'lightgray'};
  }
`;


export default function TextArea(props) {
  if (props.isSummary) {
    return <Text>{props.value || 'N/A'}</Text>;
  }
  return <Area {...props} />;
}

TextArea.propTypes = {
  isSummary: PropTypes.bool,
  value: PropTypes.any,
};




// WEBPACK FOOTER //
// ./app/containers/FastCover/components/TextArea/index.js